import { ElementRef, HostListener } from '@angular/core';

export class DigitOnlyBase {
  regex: RegExp;
  constructor(protected inputElement: ElementRef) {}
  @HostListener('keypress', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (e.key) {
      if (
        [
          'Delete',
          'Backspace',
          'Tab',
          'Escape',
          'Enter',
          'ArrowLeft',
          'ArrowRight',
          'ArrowUp',
          'ArrowDown',
          'Home',
          'End'
        ].indexOf(e.key) !== -1
      ) {
        return;
      }

      if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(e.key) !== -1) {
        return;
      }
      // Allow: Ctrl+A Ctrl+C Ctrl+V Ctrl+X Cmd+A (Mac) Cmd+C (Mac) Cmd+V (Mac) Cmd+X (Mac)
      if (
        ['a', 'A', 'c', 'C', 'v', 'V', 'x', 'X'].indexOf(e.key) !== -1 &&
        (e.ctrlKey === true || e.metaKey === true)
      ) {
        return;
      }
      if (this.allowKey(e)) {
        return;
      }
      e.preventDefault();
    }
  }
  // é¢å¤åè®¸è¾å¥çé®å¼
  allowKey(e: KeyboardEvent): boolean {
    return false;
  }

  @HostListener('keyup')
  onkeyup() {
    if (this.regex) {
      let value = String(this.inputElement.nativeElement.value);
      if (value) {
        value = value.replace(this.regex, '');
        this.inputElement.nativeElement.value = Number(value);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string = event.clipboardData.getData('text/plain').replace(this.regex, ''); // get a digit-only string
    document.execCommand('insertText', false, pastedInput);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer.getData('text').replace(this.regex, '');
    this.inputElement.nativeElement.focus();
    document.execCommand('insertText', false, textData);
  }
}
